<template>
  <div class="mv-10 hidden-xs-only">
    <el-popover placement="bottom-end" trigger="click" @show="queryRecords">
      <div class="dst-ref-button" slot="reference">
        <el-tooltip content="Show audit logs" placement="bottom">
          <el-button
            class="table-action-button icon-orange"
            icon="el-icon-view"
          >
          </el-button>
        </el-tooltip>
      </div>

      <div class="flex">
        <el-button class="mb-10" @click="doExport">
          Export
        </el-button>

        <div class="box right">
          <el-tag class="mb-10">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Showing last 10 days
          </el-tag>
        </div>
      </div>

      <div
        class="vxe-table card-base card-shadow--medium"
        style="height: 350px;"
      >
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          resizable
          highlight-hover-row
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :columns="tableColumns"
          :loading="tableLoading"
        />
      </div>
    </el-popover>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import moment from "moment-timezone";

export default {
  name: "RecentAuditCapture",
  props: {
    record: { required: true },
    service: { required: true }
  },

  data() {
    return {
      limit: 300,
      start: null,
      end: null,
      exportCSV: false,
      actions: ["Create", "Update", "Delete"],
      tableLoading: false,
      tableData: [],
      tableColumns: [
        {
          field: "time",
          title: "Time",
          minWidth: 175,
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<span>{this.timeFormatter(row.time)}</span>];
            }
          }
        },
        {
          field: "userEmail",
          title: "Email",
          minWidth: 225,
          sortable: true,
          showOverflow: true
        },
        {
          field: "action",
          title: "Action",
          minWidth: 100,
          sortable: true
        }
      ]
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    record() {
      this.tableData = [];
    }
  },

  methods: {
    doExport() {
      this.exportCSV = true;
      this.queryRecords();
    },

    queryRecords() {
      if (!this.tableData.length || this.exportCSV === true) {
        this.start = moment()
          .subtract(10, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.end = moment();

        this.tableLoading = true;
        feathersClient
          .service("audit-logs")
          .find({
            query: {
              start: this.start,
              end: this.end,
              primaryFilter: "record",
              actions: this.actions,
              recordId: this.record.id,
              tenantId: this.record.tenantId ? this.record.tenantId : 0,
							service: this.service,
              $limit: this.limit,
              $skip: 0,
              timezone: this.user.timezone,
              exportCSV: this.exportCSV
            }
          })
          .then(res => {
            if (!this.exportCSV) {
              this.tableData = res.data;
            }

            if (this.exportCSV) {
              this.downloadCSV(res);
            }
            this.exportCSV = false;
            this.tableLoading = false;
          })
          .catch(res => {
            this.tableLoading = false;
          });
      }
    },

    downloadCSV(data) {
      const fileBlob = new Blob([data.file]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(fileBlob);
      link.download = data.downloadName;
      link.click();
    },

    timeFormatter(val) {
      return val ? moment(val).format("M/DD h:mm:ss A") : val;
    }
  }
};
</script>

<style lang="scss" scoped>
.dst-ref-button {
  position: fixed;
  top: 80px;
  right: 20px;
}
</style>
